(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCarousel(wrapper) {
      const track = wrapper.querySelector('.mobile-carousel__track');
      const dotsContainer = wrapper.querySelector('.mobile-carousel__dots');
      if (!track || !dotsContainer) return;

      const slides = () => Array.from(track.children);

      // Build dots
      function buildDots() {
        const s = slides();
        if (s.length <= 1) return;
        dotsContainer.innerHTML = '';
        s.forEach((_, i) => {
          const btn = document.createElement('button');
          btn.className = 'mobile-carousel__dot';
          btn.setAttribute('aria-label', `Slide ${i + 1}`);
          btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          btn.addEventListener('click', () => {
            const target = slides()[i];
            if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          });
          dotsContainer.appendChild(btn);
        });
      }

      function currentIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function updateDots(index) {
        dotsContainer.querySelectorAll('.mobile-carousel__dot').forEach((dot, i) => {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      let timer;
      track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => updateDots(currentIndex()), 50);
      }, { passive: true });

      buildDots();
    }

    // Only initialise on mobile — avoids any side-effects on desktop
    function maybeInit() {
      if (window.innerWidth > 749) return;
      document.querySelectorAll('.section-content-wrapper--carousel').forEach(initCarousel);
    }

    // Run on load and on resize (debounced)
    document.addEventListener('DOMContentLoaded', maybeInit);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(maybeInit, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
